<section class="banner">
  <app-nav class="w-100"></app-nav>
  <div class="container-fluid v4-px-5 v4-adjustment">
    <div class="d-flex justify-content-between pt-5">
      <div class="d-flex mx-3">
        <!-- <img class="img-icon" src="../../../../../assets/v-4-icone/history.png" alt="loading" /> -->
        <i class="{{ skillTypeIcon }}" class="andriod"></i>
        <h2 class="font-600 v4-color-white">
          {{ skillTypeName | translator }}
        </h2>
      </div>
    </div>
    <div
      class="d-flex justify-content-between align-items-center flex-wrap my-3 mx-3 w-100"
    >
      <div class="d-flex flex-wrap">
        <span class="d-flex align-items-center">
          <span
            (click)="changeRoute('/home')"
            class="custom-bredcrum-btn d-flex align-items-center"
          >
            {{ "Homepage" | translator }}
          </span>
          <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
        </span>
        <span class="d-flex align-items-center">
          <span class="custom-bredcrum-btn font-600 d-flex align-items-center">
            {{ skillTypeName | translator }}
          </span>
        </span>
      </div>
      <div class="d-flex flex-wrap">
        <ng-container *ngIf="addTrainingProgram == false">
          <div class="align-items-center d-flex flex-wrap">
            <!-- ≥!hasPermission('SKILL_TRAINING','c') &&  -->

            <a
              (click)="addTrainingProgram = true; createCourseModal = false"
              class="create-training-btn m-2 align-items-center d-flex"
              ><i class="pi pi-plus-circle mx-2"></i
              >{{ "Add Training Program" | translator }}</a
            >

            <a
              (click)="createCourseModal = true; addTrainingProgram = false"
              *ngIf="
                (coordinatorView || hasPermission('SKILL_TRAINING', 'c')) &&
                !isExternalTrainer
              "
              class="create-training-btn m-2 align-items-center d-flex"
              ><i class="pi pi-plus-circle mx-2"></i
              >{{ "Create a training course" | translator }}
            </a>

            <a
              (click)="
                ShowDashboard = true;
                showCalender = false;
                addTrainingProgram = false
              "
              *ngIf="hasPermission('SKILL_TRAINING_PUBLISH', 'a')"
              class="create-training-btn m-2 align-items-center d-flex"
              ><i class="pi pi-chart-bar mx-2"></i
              >{{ "Show Dashboard" | translator }}</a
            >

            <a
              (click)="
                ShowDashboard = false;
                showCalender = false;
                addTrainingProgram = false
              "
              *ngIf="
                !coordinatorView &&
                (showCalender == true || ShowDashboard == true)
              "
              class="create-training-btn m-2 align-items-center d-flex"
              ><i class="pi pi-list mx-2"></i> {{ "Show List" | translator }}</a
            >

            <a
              (click)="
                ShowDashboard = false;
                showCalender = true;
                addTrainingProgram = false
              "
              *ngIf="!coordinatorView && showCalender == false"
              class="create-training-btn m-2 align-items-center d-flex"
              ><i class="pi pi-calendar mx-2"></i>
              {{ "Show Calender" | translator }}</a
            >

            <a
              [routerLink]="'/coordinator-view'"
              [hidden]="!coordinatorView"
              class="create-training-btn m-2"
              ><i class="pi pi-arrow-left mx-2"></i>{{ "Back" | translator }}
            </a>
          </div>
        </ng-container>
        <ng-container *ngIf="addTrainingProgram == true">
          <a
            (click)="addTrainingProgram = false; updateHolder = undefined "
            class="create-training-btn m-2 align-items-center d-flex"
            ><i class="pi pi-times-circle mx-2"></i
            >{{ "delete" | translator }}</a
          >
        </ng-container>
      </div>
    </div>
  </div>
</section>

<div class="container-fluid v4-bg p-1">
  <div
    class="pt-5"
    *ngIf="
      !createCourseModal &&
      !openCourseModal &&
      !addTrainer &&
      !showCalender &&
      !recreate &&
      !ShowDashboard &&
      !addTrainingProgram
    "
  >
    <span>
      <section class="container v4-select-bg">
        <div class="pt-3 d-flex justify-content-center">
          <div class="d-flex">
            <p-selectButton
            filterButton
              class="v4-active"
              styleClass="d-flex justify-content-center flex-wrap"
              (onChange)="getTrainingRequests()"
              [options]="statusOptions"
              [(ngModel)]="status"
              [multiple]="false"
              optionLabel="name"
              optionValue="value"
            ></p-selectButton>
          </div>
        </div>

        <div
          class="pt-3 d-flex justify-content-center align-items-center flex-wrap"
        >
          <div class="m-2 mob-width-100" >
            <p-treeSelect
            dir="rtl"
            filterButton
              appendTo="body"
              class="w-md-20rem w-100 v4-tree"
              containerStyleClass="w-100"
              [(ngModel)]="oufilter"
              (onNodeSelect)="getTrainingRequests()"
              [options]="selectedTreeData"
              placeholder="{{ 'Select the organizational unit' | translator }}"
              [filter]="true"
              [filterInputAutoFocus]="true"
            >
              <ng-template let-node pTemplate="default">
                <div class="d-flex">
                  <img
                    *ngIf="checkisImg(node.data); else elseBlock"
                    src="{{ staticURL }}{{ node.data }}"
                    class="img-fluid p-1 tree-img-bg"
                    style="max-height: 30px; max-width: 30px"
                  />
                  <ng-template #elseBlock>
                    <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
                  </ng-template>
                  <b class="text-nowrap">{{ node.label }}</b>
                </div>
              </ng-template>
            </p-treeSelect>
          </div>

          <div class="m-2 mob-width-100" >
            <p-dropdown
            filterButton
            dir="rtl"
              class="v4-drop"
              name="CompanyID"
              id="CompanyID"
              [options]="companyData"
              optionLabel="name"
              optionValue="_id"
              placeholder="{{ 'Select a Company' | translator }}"
              [(ngModel)]="SelectedCompanyId"
              (ngModelChange)="getTrainingRequests()"
            >
            </p-dropdown>
          </div>

          <div class="m-2 mob-width-100" >
            <p-calendar
            dir="ltr"
            filterButton
              class="text-align-start v4-calandarr"
              [(ngModel)]="DateRange"
              (ngModelChange)="onDateRangeChange()"
              selectionMode="range"
              placeholder="{{ 'date' | translator }}"
              [readonlyInput]="true"
            ></p-calendar>
          </div>

          <div class="v4-rotate">
            <i
              pTooltip="{{ 'Reset' | translator }}"
              (click)="refreshFilters()"
              tooltipPosition="top"
              class="fa-solid fa-arrows-rotate mx-3"
            ></i>
          </div>
        </div>
      </section>

      <section class="container-fluid max-1600-p-x">
        <div
          class="d-flex my-3 flex-wrap justify-content-center"
        >
          <div class="d-flex align-items-center m-2">
            <span class="color-sq-box PENDING"></span>
            <span class="color-txt mx-2">{{ "pending" | translator }}</span>
          </div>
          <div class="d-flex align-items-center m-2">
            <span class="color-sq-box REVISION"></span>
            <span class="color-txt mx-2">{{ "Revision" | translator }}</span>
          </div>
          <!-- <div class="d-flex align-items-center m-2">
                <span class="color-sq-box REJECTED"></span>
                <span class="color-txt mx-2">{{"Rejected"| translator}}</span>
            </div> -->
          <div class="d-flex align-items-center m-2">
            <span class="color-sq-box PUBLISHED"></span>
            <span class="color-txt mx-2">{{ "Published" | translator }}</span>
          </div>
          <div class="d-flex align-items-center m-2">
            <span class="color-sq-box COMPLETED"></span>
            <span class="color-txt mx-2">{{ "completed" | translator }}</span>
          </div>
        </div>
        <div class="users-data-table d-flex justify-content-center">
          <app-no-data
            [hidden]="spinner || filterRequestData.length > 0"
          ></app-no-data>
        </div>
        <div
          [hidden]="spinner || filterRequestData.length <= 0"
          class="grey-box"
        >
          <!-- <div class="grey-box"> -->
          <div class="dynamic-table-main-tr">
            <!-- Header -->
            <div class="row f-table">
              <div class="col-md-1 col-12">
                <div class="v4-bold">#</div>
              </div>
              <div class="col-md-2 col-12">
                <div class="v4-bold">
                  {{ "the address" | translator }}
                </div>
              </div>
              <div class="col-md-2 col-12">
                <div class="v4-bold">
                  {{ "Entities" | translator }}
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="v4-bold">
                  {{ "Description" | translator }}
                </div>
              </div>
              <div class="col-md-2 col-12">
                <div class="v4-bold">
                  {{ "the month" | translator }}
                </div>
              </div>
              <div
                *ngIf="status && status === 'CANCELED'"
                class="col-md-2 col-12"
              >
                <div class="v4-bold">
                  {{ "the reason of refuse" | translator }}
                </div>
              </div>
              <div class="col-md-2 col-12">
                <div class="v4-bold">
                  {{ "Action" | translator }}
                </div>
              </div>
            </div>
            <!-- End Header -->
            <ng-container
              *ngFor="let request of filterRequestData; let i = index"
            >
              <!-- Training  -->
              <ng-container *ngIf="!request.isProgram">
                <div class="row px-2 mob-my-4">
                  <div class="col-md-1 col-12 p-0 3333">
                    <div class="tabel-detail-box adjustment">
                      <div class="d-flex">
                        <div class="ms-tabel-num-box">
                          <i
                            class="fa fa-solid fa-chalkboard-user f-2rem-user"
                            (click)="op.toggle($event)"
                          ></i>
                        </div>
                      </div>
                      <div class="d-flex bold">
                        {{ i + 1 }}
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2 col-12 p-0">
                    <div class="tabel-detail-box">
                      <div class="tab-scroll">
                        {{ request?.trainingId?.title }}
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2 col-12 p-0" *ngIf="request.ou; else ous">
                    <div class="tabel-detail-box">
                      <div class="tab-scroll">
                        {{ request?.ou?.name }} ({{
                          request?.ou?.location?.name
                        }})
                      </div>
                    </div>
                  </div>

                  <ng-template #ous>
                    <div class="col-md-2 col-12 p-0"
                    pTooltip="{{getNamesString(request.ous)}}" 
                    tooltipPosition="top" 
                    >
                      <div class="tabel-detail-box">
                        <div class="tab-scroll">
                          {{ getNamesString(request.ous).substring(0,60) }} {{ getNamesString(request.ous).length > 60 ? '...' : ''}}
                        </div>
                      </div>
                    </div>
                  </ng-template>

                  <div class="col-md-2 col-12 p-0"  pTooltip="{{request?.trainingId?.description}}" 
                  tooltipPosition="top" >
                    <div class="tabel-detail-box">
                      <div class="tab-scroll">
                        {{ request?.trainingId?.description.substring(0,60) }}{{request?.trainingId?.description.length > 60 ? '...' : ''}}
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2 col-12 p-0">
                    <div class="tabel-detail-box">
                      <div class="tab-scroll d-flex align-items-center">
                        <div>{{ request.trainingId.end_date | date }}</div>
                        <div class="d-flex align-items-center mx-2">
                          <i class="full-stop"></i>
                          <div class="time-bar"></div>
                          <i class="pi pi-arrow-left icon-purple"></i>
                        </div>
                        <div>{{ request.trainingId.start_date | date }}</div>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="status && status === 'CANCELED'"
                    class="col-md-2 col-12 p-0"
                  >
                    <div class="tabel-detail-box">
                      <div class="tab-scroll">
                        {{ request?.reason ?? request?.reason | safeHTML }}
                      </div>
                    </div>
                  </div>

                  <div #targetEl class="col-md-3 col-12 p-0">
                    <div class="tabel-detail-box mob-height">
                      <div
                        class="d-flex justify-content-between w-100 align-items-center"
                      >
                        <div class="d-flex flex-wrap tab-scroll">
                          <div
                            pTooltip="{{ 'amendment' | translator }}"
                            tooltipPosition="top"
                            [hidden]="trainerView"
                            *ngIf="
                              request.status === 'TRAINING_CREATED' ||
                              request.status === 'REVISION' ||
                              request.status === 'PUBLISHED' ||
                              request.status == 'CANCELED' ||
                              hasPermission('TRAINING_EDIT_ADMIN', 'a') ||
                              hasPermission('SKILL_TRAINING', 'u')
                            "
                            (click)="openCourse(request)"
                            class="tabel-circle-btn"
                          >
                            <i class="fa-solid fa-file-pen"></i>
                          </div>

                          <div
                            pTooltip="{{ 'View' | translator }}"
                            [hidden]="! hasPermission('SKILL_TRAINING', 'r')"
                            tooltipPosition="top"
                            (click)="
                              $event.stopPropagation();
                              openCourse(request, true)
                            "
                            class="tabel-circle-btn"
                          >
                            <i class="fa fa-eye"></i>
                          </div>

                          <div pTooltip="{{ 'User Management' | translator }}" [hidden]="
                                !(hasPermission('SKILL_TRAINING', 'u'))" (click)="changeRoute('/training/user-management/'+request?.trainingId._id)"
                            tooltipPosition="top" class="tabel-circle-btn">
                            <i class="fa-solid fa-user-gear"></i>
                          </div>

                          <div
                            pTooltip="{{ 'Done With Revision' | translator }}"
                            [hidden]="!hasPermission('SKILL_TRAINING', 'u')"
                            tooltipPosition="top"
                            *ngIf="request.status === 'REVISION'"
                            (click)="
                              $event.stopPropagation();
                              approve(request?._id, 'TRAINING_CREATED')
                            "
                            class="tabel-circle-btn"
                          >
                            <i class="fa-solid fa-check"></i>
                          </div>

                          <div
                            class="tabel-circle-btn"
                            pTooltip="{{ 'Request Revision' | translator }}"
                            tooltipPosition="top"
                            [hidden]="hasPermission('SKILL_TRAINING', 'u')"
                            *ngIf="request.status === 'TRAINING_CREATED'"
                            (click)="
                              rejectReason = true;
                              rejectData.status = 'REVISION';
                              rejectData._id = request._id
                            "
                          >
                            <i class="fa-solid fa-repeat"></i>
                          </div>

                          <div
                            pTooltip="{{ 'Reject' | translator }}"
                            tooltipPosition="top"
                            [hidden]="hasPermission('SKILL_TRAINING', 'u')"
                            *ngIf="request.status === 'TRAINING_CREATED'"
                            (click)="
                              rejectReason = true;
                              rejectData.status = 'REJECTED';
                              rejectData._id = request._id
                            "
                            class="tabel-circle-btn"
                          >
                            <i class="fa-solid fa-xmark"></i>
                          </div>

                          <div
                            pTooltip="{{ 'Publish' | translator }}"
                            tooltipPosition="top"
                            *ngIf="
                              (request.status === 'TRAINING_CREATED' ||
                                request.status == 'CANCELED') &&
                              hasPermission('SKILL_TRAINING_PUBLISH', 'a')
                            "
                            (click)="
                              $event.stopPropagation();
                              openPublishModal(request?._id)
                            "
                            class="tabel-circle-btn"
                          >
                            <i class="fa-solid fa-bullhorn"></i>
                          </div>

                          <div
                            pTooltip="{{ 'View' | translator }}"
                            [hidden]="
                              !hasPermission('SKILL_TRAINING', 'r') ||
                              request.status === 'PENDING' ||
                              request.status === 'REJECTED' ||
                              request.status === 'APPROVED'
                            "
                            tooltipPosition="top"
                            (click)="
                              $event.stopPropagation();
                              openCourse(request, true)
                            "
                            class="tabel-circle-btn"
                          >
                            <i class="fa fa-eye"></i>
                          </div>

                          <div
                            pTooltip="{{ 'Assign Users' | translator }}"
                            tooltipPosition="top"
                            *ngIf="
                              request.registrationType != 'Self Registration' &&
                              request.status == 'PUBLISHED' &&
                              request.status !== 'COMPLETED'
                            "
                            (click)="
                              $event.stopPropagation(); addAttendees(request)
                            "
                            class="tabel-circle-btn"
                          >
                            <i class="fa-solid fa-user-plus"></i>
                          </div>

                          <div
                            pTooltip="{{ 'Delete training' | translator }}"
                            [hidden]="!hasPermission('SKILL_TRAINING', 'd')"
                            tooltipPosition="top"
                            *ngIf="
                              request.status !== 'PUBLISHED' &&
                              request.status !== 'COMPLETED'
                            "
                            (click)="
                              $event.stopPropagation();
                              deleteRequest(request?.trainingId?._id)
                            "
                            class="tabel-circle-btn"
                          >
                            <i class="fa fa-trash"></i>
                          </div>

                          <div
                            pTooltip="{{ 'Add to Kl' | translator }}"
                            tooltipPosition="top"
                            *ngIf="
                              request.status === 'PUBLISHED' ||
                              request.status == 'COMPLETED'
                            "
                            (click)="
                              selectKLCourse = request;
                              openAddKLModal = true;
                              viewCourse(request);
                              $event.stopPropagation()
                            "
                            class="tabel-circle-btn"
                          >
                            <i class="pi pi-book"></i>
                          </div>

                          <div
                            pTooltip="{{ 'Results' | translator }}"
                            tooltipPosition="top"
                            *ngIf="
                              (request.status === 'PUBLISHED' ||
                                request.status == 'COMPLETED') &&
                              hasPermission('SKILL_TRAINING_PUBLISH', 'a')
                            "
                            class="tabel-circle-btn"
                            [routerLink]="
                              '/training/training-results/' +
                              request?.trainingId._id
                            "
                            [queryParams]="{
                              back: '/training/skill-training/' + skillTypeId
                            }"
                          >
                            <i class="pi pi-chart-bar"></i>
                          </div>

                          <div
                            class="tabel-circle-btn"
                            pTooltip="{{ 'Cancel training' | translator }}"
                            tooltipPosition="top"
                            *ngIf="request.status === 'PUBLISHED'"
                            (click)="
                              rejectReason = true;
                              rejectData.status = 'CANCELED';
                              rejectData._id = request._id
                            "
                          >
                            <i class="fa-solid fa-ban"></i>
                          </div>
                          <div
                            *ngIf="request?.trainingId?.attendees?.length > 0"
                            class="tabel-circle-btn"
                            pTooltip="{{ 'Send Alert' | translator }}"
                            (click)="
                              showCustomAlertModal = true;
                              currentAlertTrainingId = request?.trainingId._id
                            "
                            tooltipPosition="top"
                          >
                            <i class="pi pi-bell"></i>
                          </div>
                        </div>
                        <div>
                          <i
                            pTooltip="{{
                              'Recreate Training for Pending Users' | translator
                            }}"
                            (click)="reCreateHolder = request; recreate = true"
                            [hidden]="
                              !hasPermission('SKILL_TRAINING_PUBLISH', 'a')
                            "
                            tooltipPosition="top"
                            *ngIf="
                              (request.status == 'PUBLISHED' ||
                                request.status == 'COMPLETED') &&
                              request?.pendingAttendees?.length > 0
                            "
                            class="pi pi-exclamation-triangle color-trash mr-4 p-text-secondary"
                            pBadge
                            style="font-size: 1.3rem"
                            value="{{ request?.pendingAttendees?.length }}"
                          ></i>
                          <i
                            pTooltip="{{ 'Self Registration' | translator }}"
                            tooltipPosition="top"
                            *ngIf="
                              (request.status == 'PUBLISHED' ||
                                request.status == 'COMPLETED') &&
                              request.registrationType == 'Self Registration'
                            "
                            class="fa-solid fa-user user-yellow mr-4 p-text-secondary"
                            style="font-size: 1.3rem"
                          ></i>
                          <i
                            pTooltip="{{ 'Manager Registration' | translator }}"
                            tooltipPosition="top"
                            *ngIf="
                              (request.status == 'PUBLISHED' ||
                                request.status == 'COMPLETED') &&
                              request.registrationType != 'Self Registration'
                            "
                            class="pi pi-sitemap color-trash mr-4 p-text-secondary"
                            style="font-size: 1.3rem"
                          ></i>

                          <div
                            class="tabel-circle-btn"
                            *ngIf="request.status == 'REVISION'"
                          >
                            <i
                              pTooltip="{{ 'View Revision' | translator }}"
                              (click)="
                                RevisionData = request; showRevisionModal = true
                              "
                              tooltipPosition="top"
                              class="pi pi-directions color-trash mr-4 p-text-secondary"
                              style="font-size: 1.3rem"
                            ></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p-overlayPanel
                  class="v4-p-overlay-panel"
                  [style]="{ width: '500px' }"
                  #op
                >
                  <app-training-timeline
                    [sessions]="request?.trainingId?.sessions"
                    [isToolTip]="true"
                  ></app-training-timeline>
                </p-overlayPanel>
              </ng-container>
              <!-- End Training  -->

              <!-- Training Program -->
              <ng-container *ngIf="request.isProgram">
                <div
                  class="{{
                    selectedProgram?._id == request._id
                      ? 'folder-open'
                      : 'folder'
                  }}"
                >
                  <div class="">
                    <div class="row p-0">
                      <div class="col-md-1 col-12 p-0 1111">
                        <div class="tabel-detail-box adjustment">
                          <div class="d-flex">
                            <div data-label="#" class="ms-tabel-num-box">
                              <i
                                class="pi pi-folder-open f-2rem"
                                (click)="handleProgram(request)"
                              ></i>
                            </div>
                          </div>
                          <div class="d-flex bold">
                            {{ i + 1 }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 col-12 p-0">
                        <div class="tabel-detail-box">
                          <div data-label="la wasuf" class="tab-scroll">
                            {{ request?.title }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 col-12 p-0"
                      pTooltip="{{getNamesString(request?.ous)}}" 
                      tooltipPosition="top" 
                      >
                        <div class="tabel-detail-box">
                          <div data-label="la wasuf" class="tab-scroll">
                            {{ getNamesString(request?.ous).substring(0,60) }}{{request?.ous.length > 60 ? '...' : ''}}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 col-12 p-0"
                      pTooltip="{{request?.description}}" 
                      tooltipPosition="top" 
                      >
                        <div class="tabel-detail-box">
                          <div class="tab-scroll">
                            {{ request?.description.substring(0,60) }}{{request?.description.length > 60 ? '...' : ''}}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 col-12 p-0">
                        <div class="tabel-detail-box">
                          <div class="tab-scroll d-flex align-items-center">
                            <div>{{ request?.end_date | date }}</div>
                            <div class="d-flex align-items-center mx-2">
                              <i class="full-stop"></i>
                              <div class="time-bar"></div>
                              <i class="pi pi-arrow-left icon-purple"></i>
                            </div>
                            <div>{{ request?.start_date | date }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 col-12 p-0">
                        <div class="tabel-detail-box">
                          <div class="d-flex flex-wrap tab-scroll">
                            <span  *ngIf="hasPermission('TRAINING_PROGRAM', 'u')" class="tabel-circle-btn">
                              <i
                               
                                pTooltip="{{ 'Edit' | translator }}"
                                (click)="updateTrainingProgram(request)"
                                tooltipPosition="top"
                                class="pi pi-file-edit"
                              ></i>
                            </span>
                            <span
                            *ngIf="
                              request.status == 'PENDING' &&
                              hasPermission('PROGRAM_PUBLISH', 'a')
                            "
                            class="tabel-circle-btn"
                            >
                            <i
                            pTooltip="{{ 'delete'| translator }}"
                            (click)="confirmProgramDelete(request)"
                            tooltipPosition="top"
                            class="pi pi-trash"
                            ></i>
                          </span>
                            <span
                              *ngIf="
                                request.status == 'PENDING' &&
                                hasPermission('PROGRAM_PUBLISH', 'a')
                              "
                              class="tabel-circle-btn"
                            >
                              <i
                                pTooltip="{{ 'Publish' | translator }}"
                                (click)="confirmApprove(request)"
                                tooltipPosition="top"
                                class="pi pi-megaphone"
                              ></i>
                            </span>
                            <span
                            pTooltip="{{ 'User Management' | translator }}"
                            *ngIf="hasPermission('PROGRAM_PUBLISH', 'a') || hasPermission('PROGRAM_PUBLISH', 'a')"
                            (click)="changeRoute2('training/program-user-managment/',[request?._id])"
                            tooltipPosition="top"
                            class="tabel-circle-btn"
                          >
                            <i class="fa-solid fa-user-gear"></i>
                          </span>
                          </div>
                        </div>
                      </div>
                    </div>
                   
                  </div>
                  <!-- extra single section end -->
                  <ng-container
                    *ngIf="
                      request?.courses.length > 0 &&
                      selectedProgram?._id == request._id
                    "
                  >
                  </ng-container>

                  <!-- Inner Training  -->
                  <ng-container
                    *ngIf="
                      request.courses.length > 0 &&
                      selectedProgram?._id == request._id
                    "
                  >
                    <h6 class="py-3">
                      {{ "Trainings in training Program" | translator}}
                    </h6>
                    <ng-container
                      *ngFor="let training of request.courses; let i = index"
                    >
                      <div class="row p-0">
                        <div class="col-md-1 col-12 p-0 2222">
                          <div class="tabel-detail-box adjustment">
                            <div class="d-flex">
                              <div data-label="#" class="ms-tabel-num-box">
                                <i
                                  (click)="inner.toggle($event)"
                                  class="fa fa-solid fa-chalkboard-user f-2rem-user"
                                ></i>
                              </div>
                            </div>
                            <div class="d-flex bold">
                              {{ i + 1 }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2 col-12 p-0">
                          <div class="tabel-detail-box">
                            <div data-label="la wasuf" class="tab-scroll">
                              {{ training.trainingId.title }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-md-2 col-12 p-0"
                          *ngIf="training.ou; else ous"
                        >
                          <div class="tabel-detail-box">
                            <div data-label="la wasuf" class="tab-scroll">
                              {{ training?.ou?.name }} ({{
                                training?.ou?.location?.name
                              }})
                            </div>
                          </div>
                        </div>
                        <ng-template #ous>
                          <div class="col-md-2 col-12 p-0"
                          pTooltip="{{getNamesString(training?.ous)}}" 
                          tooltipPosition="top"
                          >
                            <div class="tabel-detail-box">
                              <div data-label="la wasuf" class="tab-scroll">
                                {{ getNamesString(training?.ous).substring(0,60) }} {{getNamesString(training?.ous).length > 60 ? '...' : '' }}
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <div class="col-md-2 col-12 p-0"  pTooltip="{{training.trainingId?.description }}" 
                        tooltipPosition="top" >
                          <div class="tabel-detail-box">
                            <div class="tab-scroll">
                              {{ training.trainingId?.description.substring(0,60) }}{{training.trainingId?.description?.length > 60 ? '...' : '' }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2 col-12 p-0">
                          <div class="tabel-detail-box">
                            <div class="tab-scroll d-flex align-items-center">
                              <div>
                                {{ training?.trainingId?.end_date | date }}
                              </div>
                              <div class="d-flex align-items-center mx-2">
                                <i class="full-stop"></i>
                                <div class="time-bar"></div>
                                <i class="pi pi-arrow-left icon-purple"></i>
                              </div>
                              <div>
                                {{ training?.trainingId?.start_date | date }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          *ngIf="status && status === 'CANCELED'"
                          class="col-md-2 col-12 p-0"
                        >
                          <div class="tabel-detail-box">
                            <div class="tab-scroll">
                              {{ request?.reason ?? request?.reason }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3 col-12 p-0">
                          <div class="tabel-detail-box mob-height">
                            <div
                              class="d-flex justify-content-between w-100 align-items-center"
                            >
                              <div class="d-flex flex-wrap tab-scroll">
                                <div
                                  pTooltip="{{ 'amendment' | translator }}"
                                  tooltipPosition="top"
                                  [hidden]="trainerView"
                                  *ngIf="
                                    training.status === 'TRAINING_CREATED' ||
                                    training.status === 'REVISION' ||
                                    training.status === 'PUBLISHED' ||
                                    training.status == 'CANCELED' ||
                                    hasPermission('TRAINING_EDIT_ADMIN', 'a') ||
                                    hasPermission('SKILL_TRAINING', 'u')
                                  "
                                  (click)="openCourse(training)"
                                  class="tabel-circle-btn"
                                >
                                  <i class="fa-solid fa-file-pen"></i>
                                </div>

                                <!-- <div
                                  pTooltip="{{ 'View' | translator }}"
                                  [hidden]="!managerPage"
                                  tooltipPosition="top"
                                  (click)="
                                    $event.stopPropagation();
                                    openCourse(training, true)
                                  "
                                  class="tabel-circle-btn"
                                >
                                  <i class="fa fa-eye"></i>
                                </div> -->

                                <div
                                  pTooltip="{{
                                    'Done With Revision' | translator
                                  }}"
                                  
                                  tooltipPosition="top"
                                  *ngIf="training.status === 'REVISION'"
                                  (click)="
                                    $event.stopPropagation();
                                    approve(training?._id, 'TRAINING_CREATED')
                                  "
                                  class="tabel-circle-btn"
                                >
                                  <i class="fa-solid fa-check"></i>
                                </div>

                                <div pTooltip="{{ 'User Management' | translator }}" 
                                [hidden]="!( hasPermission('SKILL_TRAINING', 'u'))"
                                 (click)="changeRoute('/training/user-management/'+training?.trainingId._id)"
                                  tooltipPosition="top" class="tabel-circle-btn">
                                  <i class="fa-solid fa-user-gear"></i>
                                </div>

                                <div
                                  class="tabel-circle-btn"
                                  pTooltip="{{
                                    'Request Revision' | translator
                                  }}"
                                  tooltipPosition="top"
                                  *ngIf="training.status === 'TRAINING_CREATED'"
                                  (click)="
                                    rejectReason = true;
                                    rejectData.status = 'REVISION';
                                    rejectData._id = training._id
                                  "
                                >
                                  <i class="fa-solid fa-repeat"></i>
                                </div>

                                <!-- <div
                                  pTooltip="{{ 'Reject' | translator }}"
                                  tooltipPosition="top"
                                  [hidden]="managerPage"
                                  *ngIf="training.status === 'TRAINING_CREATED'"
                                  (click)="
                                    rejectReason = true;
                                    rejectData.status = 'REJECTED';
                                    rejectData._id = training._id
                                  "
                                  class="tabel-circle-btn"
                                >
                                  <i class="fa-solid fa-xmark"></i>
                                </div> -->

                                <!-- <div
                                  pTooltip="{{ 'Publish' | translator }}"
                                  tooltipPosition="top"
                                  *ngIf="
                                    (training.status === 'TRAINING_CREATED' ||
                                      training.status == 'CANCELED') &&
                                    hasPermission('SKILL_TRAINING_PUBLISH', 'a')
                                  "
                                  (click)="
                                    $event.stopPropagation();
                                    openPublishModal(training?._id)
                                  "
                                  class="tabel-circle-btn"
                                >
                                  <i class="fa-solid fa-bullhorn"></i>
                                </div> -->

                                <div
                                  pTooltip="{{ 'View' | translator }}"
                                  [hidden]="
                                    !hasPermission('SKILL_TRAINING', 'r') ||
                                    training.status === 'PENDING' ||
                                    training.status === 'REJECTED' ||
                                    training.status === 'APPROVED'
                                  "
                                  tooltipPosition="top"
                                  (click)="
                                    $event.stopPropagation();
                                    openCourse(training, true)
                                  "
                                  class="tabel-circle-btn"
                                >
                                  <i class="fa fa-eye"></i>
                                </div>

                                <!-- <div
                                  pTooltip="{{ 'Assign Users' | translator }}"
                                  [hidden]="!managerPage"
                                  tooltipPosition="top"
                                  *ngIf="
                                    training.registrationType !=
                                      'Self Registration' &&
                                    training.status == 'PUBLISHED' &&
                                    training.status !== 'COMPLETED'
                                  "
                                  (click)="
                                    $event.stopPropagation();
                                    addAttendees(training)
                                  "
                                  class="tabel-circle-btn"
                                >
                                  <i class="fa-solid fa-user-plus"></i>
                                </div> -->

                                <!-- <div
                                  pTooltip="{{
                                    'Delete training' | translator
                                  }}"
                                  [hidden]="
                                    !hasPermission('SKILL_TRAINING', 'd')
                                  "
                                  tooltipPosition="top"
                                  *ngIf="
                                    training.status !== 'PUBLISHED' &&
                                    training.status !== 'COMPLETED'
                                  "
                                  (click)="
                                    $event.stopPropagation();
                                    deleteRequest(training?.trainingId?._id)
                                  "
                                  class="tabel-circle-btn"
                                >
                                  <i class="fa fa-trash"></i>
                                </div> -->

                                <!-- <div
                                  pTooltip="{{ 'Add to Kl' | translator }}"
                                  tooltipPosition="top"
                                  [hidden]="managerPage"
                                  *ngIf="
                                    training.status === 'PUBLISHED' ||
                                    training.status == 'COMPLETED'
                                  "
                                  (click)="
                                    selectKLCourse = training;
                                    openAddKLModal = true;
                                    viewCourse(training);
                                    $event.stopPropagation()
                                  "
                                  class="tabel-circle-btn"
                                >
                                  <i class="pi pi-book"></i>
                                </div> -->

                                <div
                                  pTooltip="{{ 'Results' | translator }}"
                                  tooltipPosition="top"
                                  *ngIf="
                                    (training.status === 'PUBLISHED' ||
                                      training.status == 'COMPLETED') &&
                                    hasPermission('SKILL_TRAINING_PUBLISH', 'a')
                                  "
                                  class="tabel-circle-btn"
                                  [routerLink]="
                                    '/training/training-results/' +
                                    training?.trainingId._id
                                  "
                                  [queryParams]="{
                                    back:
                                      '/training/skill-training/' + skillTypeId
                                  }"
                                >
                                  <i class="pi pi-chart-bar"></i>
                                </div>

                                <div
                                  class="tabel-circle-btn"
                                  pTooltip="{{
                                    'Cancel training' | translator
                                  }}"
                                  tooltipPosition="top"
                                  *ngIf="training.status === 'PUBLISHED'"
                                  (click)="
                                    rejectReason = true;
                                    rejectData.status = 'CANCELED';
                                    rejectData._id = training._id
                                  "
                                >
                                  <i class="fa-solid fa-ban"></i>
                                </div>
                                
                                <div
                                  *ngIf="
                                    training?.trainingId?.attendees?.length > 0
                                  "
                                  class="tabel-circle-btn"
                                  pTooltip="{{ 'Send Alert' | translator }}"
                                  (click)="
                                    showCustomAlertModal = true;
                                    currentAlertTrainingId =
                                      training?.trainingId._id
                                  "
                                  tooltipPosition="top"
                                >
                                  <i class="pi pi-bell"></i>
                                </div>
                              </div>
                              <div>
                                <!-- <i
                                  pTooltip="{{
                                    'Recreate Training for Pending Users'
                                      | translator
                                  }}"
                                  (click)="
                                    reCreateHolder = training; recreate = true
                                  "
                                  [hidden]="
                                    managerPage ||
                                    !hasPermission(
                                      'SKILL_TRAINING_PUBLISH',
                                      'a'
                                    )
                                  "
                                  tooltipPosition="top"
                                  *ngIf="
                                    (training.status == 'PUBLISHED' ||
                                      training.status == 'COMPLETED') &&
                                    training?.pendingAttendees?.length > 0
                                  "
                                  class="pi pi-exclamation-triangle color-trash mr-4 p-text-secondary"
                                  pBadge
                                  style="font-size: 1.3rem"
                                  value="{{
                                    training?.pendingAttendees?.length
                                  }}"
                                ></i> -->
                                <!-- <i
                                  pTooltip="{{
                                    'Self Registration' | translator
                                  }}"
                                  tooltipPosition="top"
                                  *ngIf="
                                    (training.status == 'PUBLISHED' ||
                                      training.status == 'COMPLETED') &&
                                    training.registrationType ==
                                      'Self Registration'
                                  "
                                  class="fa-solid fa-user user-yellow mr-4 p-text-secondary"
                                  style="font-size: 1.3rem"
                                ></i>

                                <i
                                  pTooltip="{{
                                    'Manager Registration' | translator
                                  }}"
                                  tooltipPosition="top"
                                  *ngIf="
                                    (training.status == 'PUBLISHED' ||
                                      training.status == 'COMPLETED') &&
                                    training.registrationType !=
                                      'Self Registration'
                                  "
                                  class="pi pi-sitemap color-trash mr-4 p-text-secondary"
                                  style="font-size: 1.3rem"
                                ></i> -->

                                <div
                                  class="tabel-circle-btn"
                                  *ngIf="training.status == 'REVISION'"
                                >
                                  <i
                                    pTooltip="{{
                                      'View Revision' | translator
                                    }}"
                                    (click)="
                                      RevisionData = training;
                                      showRevisionModal = true
                                    "
                                    tooltipPosition="top"
                                    class="pi pi-directions color-trash mr-4 p-text-secondary"
                                    style="font-size: 1.3rem"
                                  ></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p-overlayPanel
                        class="v4-p-overlay-panel"
                        [style]="{ width: '500px' }"
                        #inner
                      >
                        <app-training-timeline
                          [sessions]="training?.trainingId?.sessions"
                          [isToolTip]="true"
                        ></app-training-timeline>
                      </p-overlayPanel>
                    </ng-container>
                  </ng-container>
                  <!-- End Inner Training  -->
                </div>
              </ng-container>
              <!-- End Training Program -->
            </ng-container>
          </div>
          <!-- </div> -->

          <!-- <table>
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>{{ "the address" | translator }}</th>
            <th>{{ "Description" | translator }}</th>
            <th>{{ "the month" | translator }}</th>
            <th>{{ "Action" | translator }}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="pointer" *ngFor="let request of filterRequestData; let i = index" #targetEl
            (click)="op.toggle($event)">
            <p-overlayPanel class="v4-p-overlay-panel" [style]="{'width': '500px'}" #op>
              <app-training-timeline [sessions]="request?.trainingId?.sessions"
                [isToolTip]="true"></app-training-timeline>
            </p-overlayPanel>
            <td style="width: 0px !important; background: transparent">
              <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                <div class="d-flex tab-num-border-white">
                  <div class="tabel-detail-box">
                    <div class="ms-tabel-num-box">
                      {{ i + 1 }}
                    </div>
                  </div>
                </div>
              </span>
            </td>
            <td data-label="">
              <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                <div class="tabel-detail-box">
                  <span class="tab-scroll">{{ request?.trainingId?.title }}
                    &nbsp;&nbsp;
                    <span *ngIf="request.recreationCount > 0">({{ "Iteration" | translator }}
                      {{ request.recreationCount }})</span></span>
                </div>
              </span>
            </td>

            <td data-label="" class="fix-width">
              <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                <div class="tabel-detail-box">
                  <span class="tab-scroll" [innerHTML]="request?.trainingId?.description | safeHTML">{{
                    request?.trainingId?.description }}</span>
                </div>
              </span>
            </td>

            <td data-label="">
              <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                <div class="tabel-detail-box">
                  <span class="tab-scroll">
                    {{ request?.trainingId?.end_date | date }} -
                    {{ request?.trainingId?.start_date | date }}</span>
                </div>
              </span>
            </td>

            <td data-label="">
              <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                <div class="tabel-detail-box mob-height">
                  <div class="d-flex justify-content-between w-100 align-items-center">
                    <div class="d-flex flex-wrap">
                      <div pTooltip="{{ 'amendment' | translator }}" tooltipPosition="top" [hidden]="trainerView" *ngIf="
                          request.status === 'TRAINING_CREATED' ||
                          request.status === 'REVISION' ||
                          request.status === 'PUBLISHED' ||
                          request.status == 'CANCELED' ||
                          hasPermission('TRAINING_EDIT_ADMIN', 'a') ||
                          hasPermission('SKILL_TRAINING', 'u')
                        " (click)="openCourse(request)" class="tabel-circle-btn">
                        <i class="fa-solid fa-file-pen"></i>
                      </div>

                      <div pTooltip="{{ 'View' | translator }}" [hidden]="!managerPage" tooltipPosition="top"
                        (click)="$event.stopPropagation(); openCourse(request, true)" class="tabel-circle-btn">
                        <i class="fa fa-eye"></i>
                      </div>

                      <div pTooltip="{{ 'Done With Revision' | translator }}" [hidden]="!managerPage"
                        tooltipPosition="top" *ngIf="request.status === 'REVISION'"
                        (click)="$event.stopPropagation();approve(request?._id, 'TRAINING_CREATED')"
                        class="tabel-circle-btn">
                        <i class="fa-solid fa-check"></i>
                      </div>

                      <div class="tabel-circle-btn" pTooltip="{{ 'Request Revision' | translator }}"
                        tooltipPosition="top" [hidden]="managerPage" *ngIf="request.status === 'TRAINING_CREATED'"
                        (click)="
                          rejectReason = true;
                          rejectData.status = 'REVISION';
                          rejectData._id = request._id
                        ">
                        <i class="fa-solid fa-repeat"></i>
                      </div>

                      <div pTooltip="{{ 'Reject' | translator }}" tooltipPosition="top" [hidden]="managerPage"
                        *ngIf="request.status === 'TRAINING_CREATED'" (click)="
                          rejectReason = true;
                          rejectData.status = 'REJECTED';
                          rejectData._id = request._id
                        " class="tabel-circle-btn">
                        <i class="fa-solid fa-xmark"></i>
                      </div>

                    
                      <div pTooltip="{{ 'Publish' | translator }}" tooltipPosition="top" *ngIf="
                          (request.status === 'TRAINING_CREATED' ||
                            request.status == 'CANCELED') &&
                          hasPermission('SKILL_TRAINING_PUBLISH', 'a')
                        " (click)="$event.stopPropagation();openPublishModal(request?._id)" class="tabel-circle-btn">
                        <i class="fa-solid fa-bullhorn"></i>
                      </div>

                      <div pTooltip="{{ 'View' | translator }}" [hidden]="
                          managerPage ||
                          !hasPermission('SKILL_TRAINING', 'r') ||
                          request.status === 'PENDING' ||
                          request.status === 'REJECTED' ||
                          request.status === 'APPROVED'
                        " tooltipPosition="top" (click)="$event.stopPropagation();openCourse(request, true)"
                        class="tabel-circle-btn">
                        <i class="fa fa-eye"></i>
                      </div>

                      <div pTooltip="{{ 'Assign Users' | translator }}" [hidden]="!managerPage" tooltipPosition="top"
                        *ngIf="
                          request.registrationType != 'Self Registration' &&
                          request.status == 'PUBLISHED' &&
                          request.status !== 'COMPLETED'
                        " (click)="$event.stopPropagation();addAttendees(request)" class="tabel-circle-btn">
                        <i class="fa-solid fa-user-plus"></i>
                      </div>

                      <div pTooltip="{{ 'Delete training' | translator }}" [hidden]="!hasPermission('SKILL_TRAINING', 'd')
                        " tooltipPosition="top" *ngIf="
                          request.status !== 'PUBLISHED' &&
                          request.status !== 'COMPLETED'
                        " (click)="$event.stopPropagation();deleteRequest(request?.trainingId?._id)" class="tabel-circle-btn">
                        <i class="fa fa-trash"></i>
                      </div>

                      <div pTooltip="{{ 'Add to Kl' | translator }}" tooltipPosition="top" [hidden]="managerPage" *ngIf="
                          request.status === 'PUBLISHED' ||
                          request.status == 'COMPLETED'
                        " (click)="
                          selectKLCourse = request;
                          openAddKLModal = true;
                          viewCourse(request);$event.stopPropagation()
                        " class="tabel-circle-btn">
                        <i class="pi pi-book"></i>
                      </div>

                      <div pTooltip="{{ 'Results' | translator }}" tooltipPosition="top" *ngIf=" (request.status === 'PUBLISHED' ||
                          request.status == 'COMPLETED') &&
                          hasPermission('SKILL_TRAINING_PUBLISH', 'a')"  class="tabel-circle-btn"
                        [routerLink]="'/training/training-results/' + request?.trainingId._id"
                        [queryParams]="{ back: '/training/skill-training/' + skillTypeId }"
                        >
                        <i class="pi pi-chart-bar"></i>
                      </div>

                      <div class="tabel-circle-btn" pTooltip="{{ 'Cancel training' | translator }}"
                        tooltipPosition="top" [hidden]="managerPage" *ngIf="request.status === 'PUBLISHED'" (click)="
                          rejectReason = true;
                          rejectData.status = 'CANCELED';
                          rejectData._id = request._id
                        ">
                        <i class="fa-solid fa-ban"></i>
                      </div>
                      <div *ngIf="request?.trainingId?.attendees?.length > 0" class="tabel-circle-btn"
                        pTooltip="{{ 'Send Alert' | translator }}" (click)="
                          showCustomAlertModal = true;
                          currentAlertTrainingId = request?.trainingId._id
                        " tooltipPosition="top">
                        <i class="pi pi-bell"></i>
                      </div>
                    </div>
                    <div>
                      <i pTooltip="{{
                          'Recreate Training for Pending Users' | translator
                        }}" (click)="reCreateHolder = request; recreate = true" [hidden]="
                          managerPage ||
                          !hasPermission('SKILL_TRAINING_PUBLISH', 'a')
                        " tooltipPosition="top" *ngIf="
                          (request.status == 'PUBLISHED' ||
                            request.status == 'COMPLETED') &&
                          request?.pendingAttendees?.length > 0
                        " class="pi pi-exclamation-triangle color-trash mr-4 p-text-secondary" pBadge
                        style="font-size: 1.3rem" value="{{ request?.pendingAttendees?.length }}"></i>
                      <i pTooltip="{{ 'Self Registration' | translator }}" tooltipPosition="top" *ngIf="
                          (request.status == 'PUBLISHED' ||
                            request.status == 'COMPLETED') &&
                          request.registrationType == 'Self Registration'
                        " class="fa-solid fa-user user-yellow mr-4 p-text-secondary" style="font-size: 1.3rem"></i>
                      <i pTooltip="{{ 'Manager Registration' | translator }}" tooltipPosition="top" *ngIf="
                          (request.status == 'PUBLISHED' ||
                            request.status == 'COMPLETED') &&
                          request.registrationType != 'Self Registration'
                        " class="pi pi-sitemap color-trash mr-4 p-text-secondary" style="font-size: 1.3rem"></i>

                      <div class="tabel-circle-btn" *ngIf="request.status == 'REVISION'">
                        <i pTooltip="{{ 'View Revision' | translator }}" (click)="
                            RevisionData = request; showRevisionModal = true
                          " tooltipPosition="top" class="pi pi-directions color-trash mr-4 p-text-secondary"
                          style="font-size: 1.3rem"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </td>
          </tr>
        </tbody>
      </table> -->
        </div>
        <div class="mb-5 flex justify-content-center">
          <p-paginator
            [hidden]="totalTraining <= 0"
            (onPageChange)="onPageChange($event)"
            [first]="first"
            [rows]="rows"
            [totalRecords]="totalTraining"
            [rowsPerPageOptions]="[10, 20, 30]"
          ></p-paginator>
        </div>
        <div class="d-flex justify-content-center">
          <p-progressSpinner
            [hidden]="!spinner"
            styleClass="w-4rem h-4rem pb-4"
            strokeWidth="8"
            fill="var(--surface-ground)"
            animationDuration=".5s"
          ></p-progressSpinner>
        </div>
      </section>
    </span>
  </div>

  <app-training-dashboard
    *ngIf="
      ShowDashboard &&
      !createCourseModal &&
      !openCourseModal &&
      !showCalender &&
      !addTrainer &&
      !addTrainingProgram
    "
    [tab]="this.selected"
  >
  </app-training-dashboard>

  <app-training-calander
    *ngIf="
      showCalender &&
      !ShowDashboard &&
      !createCourseModal &&
      !openCourseModal &&
      !addTrainingProgram
    "
    [training_type]="this.selected"
    [query]="{ ous: true ? this.managerOu : null }"
    (showTraining)="openCourse($event, true)"
  ></app-training-calander>

  <!-- {'ou' : { $in: managerOu}, _id : {$nin :usersInCourse }} -->

  <!-- Assign User -->
  <section *ngIf="addTrainer">
    <app-assign-users
      [userFetchUrl]="'user/training-users/'"
      [selectionData]="usersInCourse"
      (selectedUsersList)="assNewTrainers($event)"
      [query]="{ ous: getAllowedOus(), training: course._id }"
      *ngIf="addTrainer"
      [requestedUser]="requestedUser"
      [managerLimit]="managerLimit"
      [isTraining]="true"
    >
    </app-assign-users>
  </section>
  <!-- Assign User -->

  <section [hidden]="!recreate">
    <app-re-create
      *ngIf="recreate"
      [request]="reCreateHolder"
      [skillTypeId]="skillTypeId"
      (reCreated)="reCreated($event)"
    ></app-re-create>
  </section>

  <!-- Create Training Progaram -->
  <div *ngIf="addTrainingProgram" class="container bg-rgb mb-3 p-3">
    <ng-container *ngIf="addTrainingProgram && !updateHolder">
      <app-add-training-program
        (closeForm)="closeProgramAddFrom($event)"
        [isSkillTraining]="true"
        [programType]="this.skillTypeId"
      ></app-add-training-program>
    </ng-container>
    <ng-container *ngIf="addTrainingProgram && updateHolder">
      <app-add-training-program
        [programData]="updateHolder"
        (closeForm)="closeProgramAddFrom($event)"
        [programType]="this.skillTypeId"
        [isSkillTraining]="false"
      ></app-add-training-program>
    </ng-container>
  </div>

  <!-- End Create Training Progaram -->

  <!-- Create Course -->
  <section class="" *ngIf="createCourseModal && !openCourseModal">
    <app-create-course
      [isSkillTraining]="true"
      [skillTypeId]="skillTypeId"
      [data]="requestHolder"
      [fromCreateTraining]="fromCreateTraining"
    ></app-create-course>
  </section>
  <section class="" *ngIf="openCourseModal && !createCourseModal">
    <app-show-detail
      [pageCall]="'View'"
      *ngIf="trainingDetails != undefined"
      [permissions]="permissions"
      [courseDetails]="trainingDetails"
    ></app-show-detail>
  </section>
  <!-- End Create Course -->

  <!-- Accept Reject Modal -->
  <div class="card flex justify-content-center">
    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      header="{{ 'the reason' | translator }}"
      [(visible)]="rejectReason"
      [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '600px' }"
      [maximizable]="true"
    >
      <div class="w-100">
        <p>{{ "the reason" | translator }}</p>
        <p-editor [(ngModel)]="rejectData.reason" [style]="{ height: '320px' }">
        </p-editor>
        <p *ngIf="reasonError" style="color: red">{{ reasonError }}</p>
      </div>
      <ng-template pTemplate="footer">
        <button (click)="deactivateInit()" class="v4-btn-every">
          <i class="pi pi-check v4-ml-2"></i>{{ "OK" | translator }}
        </button>
      </ng-template>
    </p-dialog>
  </div>
  <!-- End Accept Reject Modal -->

  <!-- Publish Modal -->
  <p-dialog
    [blockScroll]="true"
    [draggable]="false"
    header="Header"
    [(visible)]="publishModal"
    [style]="{ width: '50vw' }"
  >
    <ng-template pTemplate="header">
      <span class="text-xl font-bold">{{
        "Publish Details" | translator
      }}</span>
    </ng-template>
    <div class="flex flex-column gap-3">
      <div class="column mx-2">
        <label class="label-ui my-2">{{ "Entities" | translator }}</label>
        <p-treeSelect
          appendTo="body"
          class="w-md-20rem w-100"
          containerStyleClass="w-100"
          [(ngModel)]="publishOus"
          [options]="selectedTreeData"
          selectionMode="multiple"
          [metaKeySelection]="false"
          placeholder="{{ 'Select Enitites' | translator }}"
          [filter]="true"
          [filterInputAutoFocus]="true"
        >
          <ng-template let-node pTemplate="default">
            <div class="d-flex">
              <img
                *ngIf="checkisImg(node.data); else elseBlock"
                src="{{ staticURL }}{{ node.data }}"
                class="img-fluid p-1 tree-img-bg"
                style="max-height: 30px; max-width: 30px"
              />
              <ng-template #elseBlock>
                <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
              </ng-template>
              <b class="text-nowrap">{{ node.label }}</b>
            </div>
          </ng-template>
        </p-treeSelect>
      </div>

      <div class="d-flex flex-wrap">
        <div *ngFor="let option of publishOptions" class="mx-2 field-checkbox">
          <p-radioButton
            [inputId]="option.key"
            name="option"
            [value]="option"
            [(ngModel)]="publishTo"
          ></p-radioButton>
          <label [for]="option.key" class="mx-2">{{ option.name }}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-12">
          <label class="label-ui mb-2">{{
            "Maximum number of attendees" | translator
          }}</label>
          <div>
            <p-inputNumber
              class="custum-num"
              [(ngModel)]="publishNumberOfAttendees"
              [style]="{ width: '4rem' }"
              [showButtons]="true"
              buttonLayout="vertical"
              spinnerMode="vertical"
              inputId="vertical"
              decrementButtonClass="p-button-secondary"
              incrementButtonClass="p-button-secondary"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
            ></p-inputNumber>
          </div>
        </div>

        <div
          class="col-md-6 col-12"
          *ngIf="this.publishTo.key != 'Self Registration'"
        >
          <label class="label-ui mb-2">{{
            "Maximum number of attendees form OU" | translator
          }}</label>
          <div>
            <p-inputNumber
              class="custum-num"
              [(ngModel)]="numberOfAttendeesOfOu"
              [style]="{ width: '4rem' }"
              [showButtons]="true"
              buttonLayout="vertical"
              spinnerMode="vertical"
              inputId="vertical"
              decrementButtonClass="p-button-secondary"
              incrementButtonClass="p-button-secondary"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
            ></p-inputNumber>
          </div>
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <p-button
        icon="pi pi-check"
        [disabled]="!publishOus"
        (onClick)="publish()"
        label="{{ 'publish' | translator }}"
      ></p-button>
    </ng-template>
  </p-dialog>
  <!-- End Publish Modal -->

  <!-- Reject Reason Modal -->
  <p-dialog
    header="{{ 'Reason' | translator }}"
    [(visible)]="showRevisionModal"
    [style]="{ width: '50vw' }"
  >
    <span [innerHTML]="RevisionData?.reason"> </span>
  </p-dialog>
  <!-- End Reason Modal -->

  <!-- Add to Kl Reason Modal -->
  <p-dialog
    header="{{ 'Add to Kl' | translator }}"
    [(visible)]="openAddKLModal"
    [style]="{ width: '90vw' }"
  >
    <app-add-training-kl
      *ngIf="openAddKLModal"
      [courseId]="selectKLCourse._id"
      (submitSucces)="librarySubmit($event)"
    ></app-add-training-kl>
  </p-dialog>
  <!-- End to Kl Reason Modal -->

  <!-- AssessMent Result Modal -->
  <p-dialog
    header="{{ 'Results' | translator }}"
    [(visible)]="showSelectAssessmentModal"
    [style]="{ width: '50vw' }"
  >
    <p-tabView class="v4-tabview">
      <p-tabPanel
        *ngIf="
          getAssessmentSessions(
            selectCourseForAssessmentResult?.trainingId?.sessions
          ).length > 0
        "
        [header]="'Assessments' | translator"
      >
        <div
          class="w-100 d-flex flex-column align-items-start justify-content-start gap-2"
        >
          <ng-container
            *ngFor="
              let session of getAssessmentSessions(
                selectCourseForAssessmentResult?.trainingId?.sessions
              )
            "
          >
            <span
              class="w-100 d-flex align-items-center justify-content-between"
            >
              <span style="color: white">{{ session?.title }}</span>
              <a
                (click)="openResults(session)"
                pTooltip="{{ 'Open Results' | translator }}"
                tooltipPosition="top"
                class="tabel-circle-btn"
                ><i class="pi pi-external-link"></i
              ></a>
            </span>
            <div
              class="w-100"
              style="height: 2px; background-color: rgb(228, 228, 228)"
            ></div>
          </ng-container>
        </div>
      </p-tabPanel>
      <p-tabPanel
        *ngIf="
          getSurveySessions(
            selectCourseForAssessmentResult?.trainingId?.sessions
          ).length > 0
        "
        [header]="'Surveys' | translator"
      >
        <div
          class="w-100 d-flex flex-column align-items-start justify-content-start gap-2"
        >
          <ng-container
            *ngFor="
              let session of getSurveySessions(
                selectCourseForAssessmentResult?.trainingId?.sessions
              )
            "
          >
            <span
              class="w-100 d-flex align-items-center justify-content-between"
            >
              <span style="color: white">{{ session?.title }}</span>
              <a
                (click)="openResults(session)"
                pTooltip="{{ 'Open Results' | translator }}"
                tooltipPosition="top"
                class="tabel-circle-btn"
                ><i class="pi pi-external-link"></i
              ></a>
            </span>
            <div
              class="w-100"
              style="height: 2px; background-color: rgb(228, 228, 228)"
            ></div>
          </ng-container>
        </div>
      </p-tabPanel>
    </p-tabView>
  </p-dialog>

  <app-custom-alert
    [trainingId]="currentAlertTrainingId"
    [visible]="showCustomAlertModal"
    (hide)="showCustomAlertModal = false; currentAlertTrainingId = ''"
  ></app-custom-alert>

  <!-- End Publish Modal -->
  <p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

  <app-footer></app-footer>
</div>

<p-toast></p-toast>